<template>
	<div v-if="loading">
		<div class="row">
			<div class="col-12">
				<label class="font28 font500"><i class="fas fa-donate fa-13"></i> รายการเติมเงิน</label>
			</div>
		</div>
		<div class="row mt-3">
			<div class="align-self-center ml-3">วัน / เวลา เติมเงิน</div>
			<div class="align-self-center col-12 col-md-3 mr-2">
				<date-picker class="input-date" valueType="format" lang="en" v-model="date_start"></date-picker>
			</div>
			<div class="align-self-center ml-3">ถึงวันที่</div>
			<div class="col-12 col-md-3">
				<date-picker class="input-date" valueType="format" lang="en" v-model="date_end"></date-picker>
			</div>
		</div>
		<div class="row mt-2">
			<div class="align-self-center ml-3">เลือกสถานะ</div>
			<div class="col-12 col-md-3 px-2 pt-1 mr-3">
				<select class="browser-default custom-select" v-model="seachSelect">
					<option value="0">ทั้งหมด</option>
					<option value="1">สำเร็จ</option>
					<option value="2">ไม่สำเร็จ</option>
					<option value="3">รอ</option>
				</select>
			</div>
			<button type="button" class="btn btn-search color_white font12" style="font-weight:400; margin-left:-8px" @click="Search()"><i class="fab fa-sistrix"></i> Search</button>
			<download-excel class="btn btn-exel color_white font12" :data="json_data" :fields="json_fields" worksheet="My Worksheet" name="รายการเติมเงิน" style="font-weight:400;"><i class="fas fa-file-download"></i> Excel</download-excel>
		</div>

		<div>
			<mdb-datatable :arrows="true" :data="data" striped bordered :searching="false" scrollY maxHeight="450px" />
		</div>

		<!-- <div class="border-detail p-0 mt-3">
			<div class="row">
				<div class="col-12">
					<div style="max-height:350px; overflow-y:auto; overflow-x:auto;">
						<div class="row justify-content-center text-center color_orange" style="min-width:1200px;">
							<span class="col py-3 pr-2" style="max-width:110px;  border-right: 0.5px solid #cccccc;">#</span>
							<span class="col py-3" style="border-right: 0.5px solid #cccccc;">วันที่ส่ง</span>
							<span class="col py-3" style="border-right: 0.5px solid #cccccc;">เครดิตปกติ</span>
							<span class="col py-3" style="border-right: 0.5px solid #cccccc;">สถานะ DR</span>
						</div>
						<div class="hr-horizontal mb-2"></div> 
						<div class="row justify-content-center text-center font14" style="min-width:1200px;">
							<span class="col pr-2" style="max-width:110px; border-right: 0.5px solid #cccccc;">1</span>
							<span class="col" style="border-right: 0.5px solid #cccccc;">20/10/2020 15:50</span>
							<span class="col" style="border-right: 0.5px solid #cccccc;">7,1002.00</span>
							<span class="col" style="border-right: 0.5px solid #cccccc;">
								<label class="btn-status-green text-white">สำเร็จ</label>
							</span>
						</div>
						<div class="row justify-content-center text-center font14" style="min-width:1200px;">
							<span class="col pr-2" style="max-width:110px; border-right: 0.5px solid #cccccc;">1</span>
							<span class="col" style="border-right: 0.5px solid #cccccc;">20/10/2020 15:50</span>
							<span class="col" style="border-right: 0.5px solid #cccccc;">7,1002.00</span>
							<span class="col" style="border-right: 0.5px solid #cccccc;">
								<label class="btn-status-red text-white">ไม่สำเร็จ</label>
							</span>
						</div>
						<div class="row justify-content-center text-center font14" style="min-width:1200px;">
							<span class="col pr-2" style="max-width:110px; border-right: 0.5px solid #cccccc;">1</span>
							<span class="col" style="border-right: 0.5px solid #cccccc;">20/10/2020 15:50</span>
							<span class="col" style="border-right: 0.5px solid #cccccc;">7,1002.00</span>
							<span class="col" style="border-right: 0.5px solid #cccccc;">
								<label class="btn-status-yellow text-white">รอ</label>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row justify-content-center mt-3">
			<paginate v-model="page" :page-count="20" :page-range="3" :margin-pages="2" :click-handler="clickCallback" :first-last-button="true" :prev-text="'<'" :next-text="'>'" :container-class="'pagination'" :page-class="'page-item'"> </paginate>
		</div> -->
		<!-- <div class="row mt-3">
			<div class="col-12 text-right px-2">
				<button type="button" class="btn btn-exel color_white font12" style="font-weight:400;"><i class="fas fa-file-download"></i> Exel</button>
			</div>
		</div> -->
	</div>
</template>

<script>
	import DatePicker from 'vue2-datepicker'
	// import paginate from 'vuejs-paginate'
	import moment from 'moment'

	import {mapGetters, mapActions} from 'vuex'
	export default {
		name: 'Topuplist',
		data() {
			return {
				date_start: new Date(),
				date_end: new Date(),
				seachSelect: '0',
				page: 1,
				loading: false,
				data: {
					columns: [
						{
							label: '#',
							field: 'id2',
							sort: true,
						},
						{
							label: 'วันที่',
							field: 'date',
							sort: true,
							format: (value) => {
								return '<div class="rows">' + moment(value).format('DD/MM/YYYY HH:mm:ss') + '</div>'
							},
						},
							{
							label: 'ก่อนฝาก',
							field: 'brefore',
							sort: true,
						},
							{
							label: 'หลังฝาก',
							field: 'after',
							sort: true,
						},
						{
							label: 'จำนวนเงิน',
							field: 'amount',
							sort: true,
						},
						{
							label: 'โปรโมชั่น',
							field: 'promotion_name',
							sort: true,
						},
						{
							label: 'เครดิตที่ได้รับ',
							field: 'credit',
							sort: true,
						},
						{
							label: 'สถานะ',
							field: 'status',
							format: (value) => {
								if (value == 3) {
									return "<div class='rows text-center font500'><span class='btn-status-yellow text-white px-4'>รอ</span></div>"
								} else if (value == 2) {
									return "<div class='rows text-center font500'><span class='btn-status-red text-white'>ไม่สำเร็จ</span></div>"
								} else {
									return "<div class='rows text-center font500'><span class='btn-status-green text-white px-3'>สำเร็จ</span></div>"
								}
							},
						},
					],
					rows: null,
				},
				json_fields: {
					ลำดับ: 'id2',
					วันที่ส่ง: 'date',
					เครดิตปกติ: 'credit',
					สถานะ: 'status',
				},
				json_data: [],
			}
		},
		components: {
			DatePicker,
			// paginate,
		},
		computed: {
			...mapGetters({
				isLogin: 'isLogin',
				user: 'user',
				token: 'token',
			}),
		},
		methods: {
			...mapActions({
				storeLogin: 'login',
				storeLoout: 'logout',
				loadsession: 'loadsession',
				callApiMotherFucker: 'callApiMotherFucker',
			}),
			async Search() {
				this.loading = false
				if (this.seachSelect == '0' && this.date_start == null && this.date_end == null) {
					await this.callApiMotherFucker({
						method: 'post',
						path: '/history/All',
						data: {},
					}).then((res) => {
						this.loading = true
						if (res.payload) {
							this.data.rows = this.$add_index(res.payload)
						}
					})
				} else {
					let datapaylod = {
						date_start: this.date_start,
						date_end: this.date_end,
						status: this.seachSelect,
					}
					await this.callApiMotherFucker({
						method: 'post',
						path: '/history/query',
						data: datapaylod,
					}).then((res) => {
						if (res.payload) {
							this.data.rows = this.$add_index(res.payload)
							this.loading = true
						}
					})
					// this.seachSelect=null
					// this.data.rows = this.data.rows.filter((val) => {
					// 	if (moment(val.date).format('YYYY-MM-DD') == this.date_start && val.status == this.seachSelect) {
					// 		return true
					// 	} else {
					// 		return false
					// 	}
					// })
					// setTimeout(() => {
					// 	this.loading = true
					// }, 50)
				}
			},
			clickCallback: function(pageNum) {
				console.log(pageNum)
			},
		},
		async mounted() {
			this.date_start = moment(new Date()).format('YYYY-MM-DD')
			this.date_end = moment(new Date()).format('YYYY-MM-DD')
			await this.callApiMotherFucker({
				method: 'post',
				path: '/history/All',
				data: {},
			}).then((res) => {
				if (res.payload) {
					this.data.rows = this.$add_index(res.payload)
					this.data.rows.forEach((data) => {
						let statustext = ''
						if (data.status == 3) {
							statustext = 'รอ'
						} else if (data.status == 2) {
							statustext = 'ไม่สำเร็จ'
						} else {
							statustext = 'สำเร็จ'
						}
						this.json_data.push({
							id2: data.id2,
							date: data.date,
							credit: data.credit,
							status: statustext,
						})
					})
					this.loading = true
				}
			})
		},
	}
</script>

<style></style>
